import React, { PureComponent } from 'react';
import './template.component.style.css';
import { connect } from 'react-redux';
import { fetchAllTemplates } from '../../../../store/action/templates.action';
import TemplateTable from './templateTable.component';

class TemplateList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      template: [],
    };
  }

  componentDidMount() {
    this._fetchAllTemplates();
  }

  _onChangeState = event => this.setState({ state: event.currentTarget.value });

  _fetchAllTemplates() {
    return fetchAllTemplates()
      .then(({ data }) => {
        this.setState({
          template: data,
        });
      })
      .catch(e => {
        console.error(e);
        return this.setState({
          template: null,
        });
      });
  }

  render() {
    return (
      <div className="flex-column align-stretch">
        <div
          className="flex-column align-stretch"
          style={{ padding: '1% 10% 0% 10%' }}
        >
          <TemplateTable
            template={this.state.template}
            history={this.props.history}
          />
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAllTemplates: () => dispatch(fetchAllTemplates()),
  };
}

export default connect(mapDispatchToProps)(TemplateList);
